type ZoomResult = {
  scale: number;
  translateX: number;
  translateY: number;
};

type Dimension = {
  width: number;
  height: number;
};
export const MIN_ZOOM = 0.05;

export const getNewFinalTranslation = (
  scale: number,
  pageDimension: Dimension,
  wrapperDimension: Dimension,
): ZoomResult => {
  const { width: pageWidth, height: pageHeight } = pageDimension;
  const { width: containerWidth, height: containerHeight } = wrapperDimension;

  // Calculate new scale
  const newScale = Math.max(MIN_ZOOM, Math.min(5, scale));

  // Calculate scaled dimensions
  const scaledWidth = pageWidth * newScale;
  const scaledHeight = pageHeight * newScale;

  const translateX = (containerWidth - scaledWidth) / 2;
  const translateY = (containerHeight - scaledHeight) / 2;

  return {
    scale: newScale,
    translateX: translateX < 0 ? 0 : translateX,
    translateY: translateY < 50 ? 50 : translateY,
  };
};
function getFitToScreenZoom(wrapperDimension: Dimension, pageDimension: Dimension) {
  const padding = 100;
  let zoom = 1;
  const { width: offsetWidth, height: offsetHeight } = wrapperDimension;
  let canvasWidth = pageDimension.width;
  let canvasHeight = pageDimension.height;
  if (offsetWidth <= 0 || offsetHeight <= 0 || canvasWidth <= 0 || canvasHeight <= 0) {
    return zoom;
  }
  canvasWidth += padding; //padding on both sides
  canvasHeight += padding; //padding on both sides
  const incrementFactor = 0.05; //check size after incrementing or decrement the factor
  if (canvasWidth < offsetWidth && canvasHeight < offsetHeight) {
    //best case go in zoom forward
    while (zoom * canvasWidth < offsetWidth && zoom * canvasHeight < offsetHeight) {
      zoom = zoom + incrementFactor;
    }
    zoom = zoom - incrementFactor;
  } else {
    //go in reverse
    while (zoom * canvasWidth > offsetWidth || zoom * canvasHeight > offsetHeight) {
      zoom = zoom - incrementFactor;
    }
  }
  return zoom;
}

export const zoomPageToFitScreen = (
  pageDimension: Dimension,
  wrapperDimension: Dimension,
): ZoomResult => {
  let scale = getFitToScreenZoom(wrapperDimension, pageDimension);
  scale = Math.max(MIN_ZOOM, scale);
  // For top-left origin, we want to center the scaled element
  const scaledWidth = pageDimension.width * scale;
  const scaledHeight = pageDimension.height * scale;
  const translateX = (wrapperDimension.width - scaledWidth) / 2;
  const translateY = (wrapperDimension.height - scaledHeight) / 2;
  return {
    scale,
    translateX: translateX,
    translateY: translateY,
  };
};
